import React from 'react'
import COLORS from '@/src/colors'
import FONTS from '@/src/fonts'
import Link from '@/components/Common/Link'
import Grid from '@mui/material/Grid'
import { getDomainSetting } from '@/lib/getDomainSettings'
import { useTheme } from '@mui/material'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import Image from 'next/image'
import Box from '@mui/material/Box'
import SETTINGS from '@/src/settings'

export const ButtonSubscription: React.FC = () => {
  const buttonStyle: React.CSSProperties = {
    borderRadius: 100,
    textAlign: 'center',
    padding: 8,
    width: 210,
    margin: '8px auto',
    fontSize: '0.8125rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontWeight: FONTS.WEIGHT.BOLD,
    alignContent: 'center',
    backgroundColor: COLORS.grayText,
    color: 'white',
  }
  const titleStyle: React.CSSProperties = {
    fontWeight: FONTS.WEIGHT.EXTRABOLD,
  }

  return (
    <Link href={`${getDomainSetting('urlExtranetGroup')}inscription?type=pharmacy`}>
      <div style={buttonStyle}>
        {t({ id: 'web_header_signup_question' })}
        <div style={titleStyle}>{t({ id: 'web_header_signup' })}</div>
      </div>
    </Link>
  )
}

const NotConnectedButtons: React.FC = () => {
  const theme = useTheme()

  const buttonStyle: React.CSSProperties = {
    borderRadius: 100,
    textAlign: 'center',
    padding: 8,
    width: '100%',
    maxWidth: 210,
    margin: '8px auto',
    fontSize: theme.typography.pxToRem(13),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    fontWeight: FONTS.WEIGHT.BOLD,
    alignContent: 'center',
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  }

  return (
    <Grid container spacing={1} alignItems={'center'}>
      <Grid item xs={5} md={5} sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Box
          sx={{
            fontSize: theme.typography.pxToRem(13),
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          <Image
            src={'/images/icons/call.png'}
            alt={'call'}
            width={20}
            height={20}
            style={{ marginRight: 8 }}
          />{' '}
          {SETTINGS.contact.phone_pharmedistore}
        </Box>
      </Grid>
      <Grid item xs={12} sm={7} md={7}>
        <Link route={'LoginRedirect'}>
          <div style={buttonStyle}>
            <PersonOutlineIcon /> Connexion pharmacien
          </div>
        </Link>
      </Grid>
    </Grid>
  )
}

export default NotConnectedButtons
